import { Auth } from 'aws-amplify';
import jwt_decode from "jwt-decode";

const IMPERSONATOR_TOKEN_KEY = "NALURI_IMPERSONATOR_TOKEN"
const IMPERSONATED_COACH_TOKEN_KEY = "NALURI_COACH_TOKEN"

export const currentImpersonatorToken = () => {
    return localStorage.getItem(IMPERSONATOR_TOKEN_KEY)
}

export const hasImpersonatedCoachToken = () => {
    return localStorage.getItem(IMPERSONATED_COACH_TOKEN_KEY) !== null
}

export const setImpersonatorToken = (token) => {
  localStorage.setItem(IMPERSONATOR_TOKEN_KEY, token)
}

export const setImpersonatedCoachToken = (token) => {
  localStorage.setItem(IMPERSONATED_COACH_TOKEN_KEY, token)
}

export const logoutImpersonator = () => {
  localStorage.removeItem(IMPERSONATED_COACH_TOKEN_KEY)
  localStorage.removeItem(IMPERSONATOR_TOKEN_KEY)
}

export const currentToken = async () => {
  try {
    const res = await Auth.currentSession()
    return res.idToken.jwtToken
  } catch (err) {
    let coachToken = localStorage.getItem(IMPERSONATED_COACH_TOKEN_KEY)
    if (coachToken) { return coachToken }

    throw err;
  }
}

export const currentTokenInfo = async () => {
  try {
    const res = await Auth.currentSession()
    return {
      token: res.idToken.jwtToken,
      userId: res.idToken.payload.sub
    }
  } catch (err) {
    let coachToken = localStorage.getItem(IMPERSONATED_COACH_TOKEN_KEY)
    let jwtInfo = jwt_decode(coachToken)
    if (coachToken) {
      return {
        token: coachToken,
        userId: jwtInfo.sub
      }
    }

    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/common/auth.js